module.exports = __webpack_public_path__ + "img/ic_profile_coin.d8e244d3.png";